// extracted by mini-css-extract-plugin
module.exports = {"container":"LosPluginItem_container__1oeHr","underlined":"LosPluginItem_underlined__1mjqz","item":"LosPluginItem_item__3BKQs","detailsBtn":"LosPluginItem_detailsBtn__3XmJ3"};